import { icons } from 'src/assets/dist/svg/icons';

const socialIcons = icons.filter(icon => icon.startsWith('social-icon-'));

const urlPatterns = [
  { platform: 'youtube', regex: /(?:youtube\.com|youtu\.be)/i },
  { platform: 'whatsapp', regex: /(?:whatsapp\.com|wa\.me)/i },
  { platform: 'twitter', regex: /(?:twitter\.com|x\.com)/i },
  { platform: 'tumblr', regex: /(?:tumblr\.com)/i },
  { platform: 'tiktok', regex: /(?:tiktok\.com)/i },
  { platform: 'spotify', regex: /(?:spotify\.com|spoti\.fi)/i },
  { platform: 'soundcloud', regex: /(?:soundcloud\.com)/i },
  { platform: 'medium', regex: /(?:medium\.com)/i },
  { platform: 'instagram', regex: /(?:instagram\.com|instagr\.am)/i },
  { platform: 'flickr', regex: /(?:flickr\.com)/i },
  { platform: 'facebook', regex: /(?:facebook\.com|fb\.com)/i },
  { platform: 'facebook-chat', regex: /(?:messenger\.com|fb\.me)/i },
  { platform: 'discord', regex: /(?:discord\.com|discordapp\.com|discord\.gg)/i },
  { platform: 'deezer', regex: /(?:deezer\.com|deezer\.page\.link)/i },
  { platform: 'itunes', regex: /(?:music\.apple\.com|apple\.co)/i },
];

export function getSocialIconForUrl(url: string): string {
  const match = urlPatterns.find(pattern => pattern.regex.test(url));

  if (!match) {
    return 'social-icon-website';
  }
  return socialIcons.find(a => a.includes(match.platform)) || 'social-icon-website';
}
